import { useEffect, useState } from "react";
import server, { requests } from "../../core/api";

type StateType = {
    isLoading: boolean;
    mainShow: {
        [key: string]: string;
    },
    shows: any[]
};

function useShows() {
    
    const [state, setState] = useState<StateType>({ isLoading: true, mainShow: {}, shows: [] });
    
    useEffect(() => {
        async function getData() {
            const response = await server.get(requests.trendingThisWeek);
            if (response?.data?.results) {
                const shows = response.data.results.filter((show: any) => show.backdrop_path);
                const randomShow = shows[Math.floor(Math.random() * shows.length)]
                setState((currentState) => ({ ...currentState, mainShow: randomShow}));
            }
            const apiArray = [];
            apiArray.push(server.get(requests.netflixOriginals));
            apiArray.push(server.get(requests.topRatedMovies));
            apiArray.push(server.get(requests.actionMovies));
            apiArray.push(server.get(requests.comedyMovies));
            apiArray.push(server.get(requests.horrorMovies));
            apiArray.push(server.get(requests.romanticMovies));
            apiArray.push(server.get(requests.documentaries));
            const results = await Promise.all(apiArray);
            const [netflixOriginalResponse, topRatedResponse, actionResponse, comedyResponse, horrorReponse, romanticResponse, documentariesResponse] = results;
            const showsData = [
                {
                    title: 'Netflix Originals',
                    shows: netflixOriginalResponse.data.results.filter((show: any) => show.backdrop_path)
                },
                {
                    title: 'Top Rated Movies',
                    shows: topRatedResponse.data.results.filter((show: any) => show.backdrop_path)
                },
                {
                    title: 'Action Movies',
                    shows: actionResponse.data.results.filter((show: any) => show.backdrop_path)
                },
                {
                    title: 'Comedy Movies',
                    shows: comedyResponse.data.results.filter((show: any) => show.backdrop_path)
                },
                {
                    title: 'Horror Movies',
                    shows: horrorReponse.data.results.filter((show: any) => show.backdrop_path)
                },
                {
                    title: 'Romantic Movies',
                    shows: romanticResponse.data.results.filter((show: any) => show.backdrop_path)
                },
                {
                    title: 'Documentaries',
                    shows: documentariesResponse.data.results.filter((show: any) => show.backdrop_path)
                }
            ];
            setState((currentState) => ({ ...currentState, shows: showsData}));
            setState((currentState) => ({ ...currentState, isLoading: false}));
        }
        getData();
    }, []);

    return state;

}

export default useShows;